import './employeeSelector.scss';
import {IPromise} from "angular";
import {convertUserToUserGuiDto, UserDto} from "../../../users/model/User";

interface EmployeeSelectorScope extends ng.IScope {
    keys: any[];
    selectedEmployees: any[];
    selectedEmployeeIds: number[];
    searchEmployees: (query: string) => any[];
    updateFilterValueEmployees: () => void;
}

export class EmployeeSelector implements ng.IComponentController {

    static instance = {
        controller: ['$scope', '$mdConstant', '$mdColors', EmployeeSelector],
        template: require('./employeeSelector.html'),
        bindings: {
            "onValueChange": '=',
            "fetchFunction": '<',
            "class": '<'
        }
    };

    private $scope: EmployeeSelectorScope;
    private selectedEmployeeIds: number[];
    private onValueChange: (employeeIds: number[]) => void;
    private fetchFunction: (query: string) => IPromise<UserDto[]>;
    private $mdColors: angular.material.IColorService;

    constructor($scope,
                $mdConstant,
                $mdColors: angular.material.IColorService) {
        this.$mdColors = $mdColors;
        this.$scope = $scope;
        $scope.keys = [$mdConstant.KEY_CODE.ENTER];
        $scope.selectedEmployees = [];
        $scope.selectedEmployeeIds = [];
        $scope.searchEmployees = this.searchEmployees;
    }

    $onInit = () => {
        this.$scope.selectedEmployeeIds = this.selectedEmployeeIds;
        this.$scope.$watchCollection('selectedEmployees', this.updateFilterValueEmployees);
    };

    $postLink(): void {
        setTimeout(() => {
            let chipsInput: HTMLInputElement = document.querySelector('.employee-selector .md-chip-input-container input');
            let chipsElement: HTMLElement = document.querySelector('.employee-selector md-chips .md-chips');
            let color = this.$mdColors.getThemeColor('default-primary-200');
            chipsInput.onfocus = ($event) => {
                console.log(color);
                chipsElement.style.boxShadow = '0 2px ' + color;
            };
            chipsInput.onblur = ($event) => {
                chipsElement.style.boxShadow = '0 1px rgba(255,255,255,0.12)';
            }
        }, 1000)

    }

    searchEmployees = (searchQuery): IPromise<UserDto[]> => this.fetchFunction(searchQuery)
        .then((emplResp: UserDto[]) => convertUserToUserGuiDto(emplResp));


    updateFilterValueEmployees = (newSelectedEmployees, oldSelectedEmployees, $scope) => {
        newSelectedEmployees && this.onValueChange(newSelectedEmployees.map(e => e.id));
    };


}